import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TicketIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TicketIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 9.85257C2 9.44744 2.32842 9.11902 2.73355 9.11902H16.4666C16.8717 9.11902 17.2001 9.44744 17.2001 9.85257V12.1889C17.2001 12.594 16.8717 12.9224 16.4666 12.9224C15.7591 12.9224 15.1855 13.496 15.1855 14.2036C15.1855 14.9112 15.7591 15.4848 16.4666 15.4848C16.8717 15.4848 17.2001 15.8132 17.2001 16.2183V18.5547C17.2001 18.9598 16.8717 19.2882 16.4666 19.2882H2.73355C2.32842 19.2882 2 18.9598 2 18.5547V16.2183C2 15.8132 2.32842 15.4848 2.73355 15.4848C3.44112 15.4848 4.01475 14.9112 4.01475 14.2036C4.01475 13.4961 3.4411 12.9224 2.73355 12.9224C2.32842 12.9224 2 12.594 2 12.1889V9.85257ZM3.4671 10.5861V11.5543C4.62877 11.8753 5.48186 12.9398 5.48186 14.2036C5.48186 15.4674 4.62877 16.532 3.4671 16.8529V17.8211H6.79989V10.5861H3.4671ZM8.26699 10.5861V17.8211H15.733V16.8529C14.5713 16.5319 13.7184 15.4674 13.7184 14.2036C13.7184 12.9399 14.5713 11.8753 15.733 11.5543V10.5861H8.26699Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.79989 5.44644C6.79989 5.04131 7.12831 4.71289 7.53344 4.71289H21.2664C21.6716 4.71289 22 5.04131 22 5.44644V7.78276C22 8.18789 21.6716 8.51631 21.2664 8.51631C20.559 8.51631 19.9854 9.08987 19.9854 9.79752C19.9854 10.5051 20.5589 11.0787 21.2664 11.0787C21.6716 11.0787 22 11.4071 22 11.8122V14.1485C22 14.5537 21.6716 14.8821 21.2664 14.8821H14.4519C14.0468 14.8821 13.7184 14.5537 13.7184 14.1485C13.7184 13.7434 14.0468 13.415 14.4519 13.415H20.5329V12.4468C19.3712 12.1258 18.5183 11.0612 18.5183 9.79752C18.5183 8.53374 19.3712 7.46916 20.5329 7.1482V6.17999H13.0669V9.79749C13.0669 10.2026 12.7385 10.531 12.3333 10.531C11.9282 10.531 11.5998 10.2026 11.5998 9.79749V6.17999H8.26699V7.1482C9.42866 7.46915 10.2817 8.5337 10.2817 9.79752C10.2817 10.2026 9.95332 10.5311 9.54819 10.5311C9.14306 10.5311 8.81464 10.2026 8.81464 9.79752C8.81464 9.08993 8.24099 8.51631 7.53344 8.51631C7.12831 8.51631 6.79989 8.18789 6.79989 7.78276V5.44644Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default TicketIcon;
